import React, { useState, useEffect } from 'react';
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import PropTypes from 'prop-types';
import { Plus } from "react-feather";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
};

const SingleMenu = ({ title, underTitle, description, section, onselect, onAdd }) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    /* ────────────────────────────────────────
       MOBILE layout  ≤ 768px  — horizontal row
       ──────────────────────────────────────── */
    return (
      <div style={{ padding: "0px 0", margin: "2px" }}>
        <div
          onClick={onselect}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
            backgroundColor: "#fff",
            borderRadius: 14,
            boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
            padding: "12px 14px",
            cursor: onselect ? "pointer" : "default",
            border: "1px solid #f0f0f0",
            position: "relative",   // needed for absolute + button
          }}
        >
          {/* Image */}
          <div style={{
            width: 100,
            height: 100,
            borderRadius: 12,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f0f0f0",
          }}>
            {section && (
              <ImageWithBasePath
                src={section}
                alt={title}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </div>

          {/* Text content — leave right padding so text doesn't go under the + button */}
          <div style={{ flex: 1, minWidth: 0, paddingRight: 36 }}>
            <h3 style={{
              fontSize: 16,
              fontWeight: 700,
              color: "#001b44",
              margin: "0 0 4px 0",
              lineHeight: 1.2,
            }}>
              {title}
            </h3>
            {description && (
              <p style={{
                fontSize: 12,
                color: "#607D8B",
                margin: "0 0 8px 0",
                lineHeight: 1.4,
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}>
                {description}
              </p>
            )}
            <h6 style={{
              fontSize: 16,
              fontWeight: 700,
              color: "#E7592C",
              margin: 0,
            }}>
              {underTitle}
            </h6>
          </div>

          {/* Add button — absolute bottom-right with white circle */}
          {onAdd && (
            <div
              onClick={(e) => { e.stopPropagation(); onAdd(); }}
              style={{
                position: "absolute",
                bottom: 12,
                right: 14,
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundColor: "#f9fafb",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <Plus size={18} color="#E7592C" strokeWidth={2.5} />
            </div>
          )}
        </div>
      </div>
    );
  }

  /* ────────────────────────────────────────
     DESKTOP layout  > 768px  — vertical card
     ──────────────────────────────────────── */
  return (
    <div style={{ padding: "8px", height: "100%" }}>
      <div
        className="card custom-article-card"
        onClick={onselect}
        style={{
          border: "1px solid #f0f0f0",
          backgroundColor: "#fff",
          borderRadius: "16px",
          overflow: "visible",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          cursor: "pointer",
          margin: "0",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          position: "relative",
        }}
      >
        {/* Image Section */}
        <div style={{ position: "relative", width: "100%", height: "200px" }}>
          <ImageWithBasePath
            src={section}
            alt={title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            }}
          />

          {/* Floating Add Button */}
          {onAdd && (
            <div
              onClick={(e) => { e.stopPropagation(); onAdd(); }}
              style={{
                position: "absolute",
                bottom: "-20px",
                right: "16px",
                background: "#fff",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                cursor: "pointer",
                transition: "all 0.2s ease",
                zIndex: 2,
              }}
            >
              <Plus size={20} color="#E7592C" strokeWidth={2.5} />
            </div>
          )}
        </div>

        {/* Content Section */}
        <div style={{ padding: "24px 16px 16px", flex: 1, display: "flex", flexDirection: "column" }}>
          <h3 style={{
            fontSize: "17px",
            fontWeight: "700",
            margin: "0 0 6px 0",
            color: "#001b44",
            lineHeight: "1.2",
          }}>
            {title}
          </h3>
          <p style={{
            fontSize: "13px",
            color: "#6c757d",
            margin: "0 0 16px 0",
            lineHeight: "1.4",
            flex: 1,
          }}>
            {description}
          </p>
          <h6 style={{
            fontSize: "16px",
            fontWeight: "700",
            color: "#E7592C",
            margin: "0",
          }}>
            {underTitle}
          </h6>
        </div>
      </div>
    </div>
  );
};

SingleMenu.propTypes = {
  title: PropTypes.string.isRequired,
  underTitle: PropTypes.node,
  description: PropTypes.string,
  section: PropTypes.node,
  onselect: PropTypes.func,
  showAddButton: PropTypes.bool,
  onAdd: PropTypes.func,
};

export default SingleMenu;
